import React from 'react'
import {DataObjectId, Report, TaskData} from 'yougile-model'
import {useBoardStore} from '@components/board/board-store'
import {QueuedRender} from '@containers/queued-render'
import {StatsReportsTaskList} from './stats-reports-task-list'

interface QueuedStatsReportsTaskListProps {
  report: Report
  onGetTasks: (tasks: TaskData[]) => void
  boardId: DataObjectId
  className?: string
}

export const QueuedStatsReportsTaskList: React.FC<
  QueuedStatsReportsTaskListProps
> = ({report, onGetTasks, boardId, className}) => {
  const [boardState] = useBoardStore()

  return (
    <div className={className}>
      <QueuedRender
        queue={boardState.columnsRenderQueue}
        id={`stats-report-${boardId}`}
        placeholderClassName="min-w-296 inline-block"
      >
        <StatsReportsTaskList
          report={report}
          onGetTasks={onGetTasks}
          boardId={boardId}
        />
      </QueuedRender>
    </div>
  )
}
